import React from 'react';
import ReactDOM from 'react-dom/client';
import ImageProcessor from './ImageProcessor';  // 导入组件
import './index.css';  // 保留默认样式
import './i18n';  // 初始化国际化

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ImageProcessor />  {/* 使用图片处理组件 */}
  </React.StrictMode>
);